var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fix-height" },
    [
      _c("q-input", {
        directives: [
          {
            name: "currency",
            rawName: "v-currency",
            value: _vm.numberOptions,
            expression: "numberOptions",
          },
        ],
        ref: "ctext",
        staticClass: "customText",
        class: [
          _vm.prefix ? "prefix-custom-text" : "",
          _vm.beforeText ? "before-text" : "",
          _vm.afterIcon ? "customText-btn" : "",
        ],
        attrs: {
          filled: "",
          "bottom-slots": "",
          label: _vm.label,
          type: "text",
          counter: _vm.counter,
          maxlength: _vm.maxlength,
          dense: _vm.dense,
          "stack-label": "",
          prefix: _vm.prefix,
          suffix: _vm.suffix,
          mask: _vm.mask,
          placeholder: _vm.placeholder,
          "fill-mask": "",
          color: "orange-7",
          "bg-color": _vm.type === "textarea" ? "grey-1" : "",
          rules: !_vm.required ? null : [(val) => !!val || ""],
          disable: _vm.disabled || !_vm.editable,
          readonly: _vm.readonly,
        },
        on: { input: _vm.input },
        scopedSlots: _vm._u(
          [
            {
              key: "label",
              fn: function () {
                return [
                  _vm.label
                    ? _c(
                        "div",
                        { staticClass: "row items-center all-pointer-events" },
                        [
                          _c(
                            "b",
                            [
                              !_vm.required
                                ? _c("i", {
                                    staticClass:
                                      "pe-7s-note labelfrontIcon searchAreaLabelIcon",
                                  })
                                : _vm._e(),
                              _c("font", { staticClass: "formLabelTitle" }, [
                                _vm._v(_vm._s(_vm.label)),
                              ]),
                              _vm.required
                                ? _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons labelfrontIcon text-requiredColor",
                                    },
                                    [_vm._v("check")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "before",
              fn: function () {
                return [
                  _vm.beforeIcon && _vm.beforeIcon.length > 0
                    ? _vm._l(_vm.beforeIcon, function (icon, index) {
                        return _c(
                          "q-icon",
                          {
                            key: index,
                            staticClass: "textOtherIcon",
                            class: { "cursor-pointer": icon.click },
                            attrs: { name: icon.name },
                            on: {
                              click: function ($event) {
                                return _vm.iconClick(icon)
                              },
                            },
                          },
                          [
                            icon.tooltip
                              ? _c("q-tooltip", [_vm._v(_vm._s(icon.tooltip))])
                              : _vm._e(),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                  _vm.beforeText
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-text-before q-pl-xs q-pr-xs bg-blue-7 text-white",
                          },
                          [_vm._v(" " + _vm._s(_vm.beforeText) + " ")]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.prependIcon && _vm.prependIcon.length > 0
              ? {
                  key: "prepend",
                  fn: function () {
                    return _vm._l(_vm.prependIcon, function (icon, index) {
                      return _c(
                        "q-icon",
                        {
                          key: index,
                          staticClass: "textOtherIcon",
                          class: { "cursor-pointer": icon.click },
                          attrs: { name: icon.name },
                          on: {
                            click: function ($event) {
                              return _vm.iconClick(icon)
                            },
                          },
                        },
                        [
                          icon.tooltip
                            ? _c("q-tooltip", [_vm._v(_vm._s(icon.tooltip))])
                            : _vm._e(),
                        ],
                        1
                      )
                    })
                  },
                  proxy: true,
                }
              : null,
            {
              key: "append",
              fn: function () {
                return [
                  _vm._t("appendIconPre"),
                  _vm.search && !_vm.disabled && _vm.editable
                    ? _c("q-icon", {
                        staticClass: "cursor-pointer textCloseIcon",
                        attrs: { name: "search" },
                        on: { click: _vm.searchClick },
                      })
                    : _vm._e(),
                  _vm.close && !_vm.disabled && _vm.editable && !_vm.readonly
                    ? _c("q-icon", {
                        staticClass: "cursor-pointer textCloseIcon",
                        attrs: { name: "close" },
                        on: { click: _vm.closeClick },
                      })
                    : _vm._e(),
                  _vm.appendIcon && _vm.appendIcon.length > 0
                    ? _vm._l(_vm.appendIcon, function (icon, index) {
                        return _c(
                          "q-icon",
                          {
                            key: index,
                            staticClass: "textOtherIcon",
                            class: { "cursor-pointer": icon.click },
                            attrs: { name: icon.name },
                            on: {
                              click: function ($event) {
                                return _vm.iconClick(icon)
                              },
                            },
                          },
                          [
                            icon.tooltip
                              ? _c("q-tooltip", [_vm._v(_vm._s(icon.tooltip))])
                              : _vm._e(),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "after",
              fn: function () {
                return [
                  _vm._t("afterIconPre"),
                  _vm.afterIcon && _vm.afterIcon.length > 0
                    ? _vm._l(_vm.afterIcon, function (icon, index) {
                        return _c("q-btn", {
                          key: index,
                          staticClass: "textOtherIcon",
                          class: { "cursor-pointer": icon.click },
                          attrs: {
                            unelevated: "",
                            flat: "",
                            size: "xs",
                            color:
                              icon.color == "indigo"
                                ? "light-blue"
                                : icon.color,
                            icon: icon.name,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.iconClick(icon)
                            },
                          },
                        })
                      })
                    : _vm._e(),
                  _vm._t("afterIconAft"),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.vValue,
          callback: function ($$v) {
            _vm.vValue = $$v
          },
          expression: "vValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }